const FINANCIAL_REPORT = {
  title: 'Restituições',
  hexaTitle: 'Relatório financeiro',
  tooltip: {
    salesAmount: {
      title: 'Valor bruto de vendas Ambev',
      content: 'Essa é a soma dos produtos da Ambev vendidos por você no Zé.',
    },
    purchaseAmountAdjustment: {
      title: 'Correção do preço de compra',
      content:
        'Esse é o valor que o Zé te paga para corrigir seu preço de compra e garantir o markup de 20% em cima do valor que você pagou em produtos Ambev/ABI.',
    },
    salesProfit: {
      title: 'Valor recebido no app do Zé',
      content:
        'Esse é o valor que você recebeu do cliente sem contabilizar o que te pagamos.',
    },
    totalProfit: {
      title: 'Lucro final',
      content:
        'Esse é o valor que você lucrou após ter vendido todos os seus produtos Ambev/ABI. Aqui fica o valor final que inclui a correção do preço ideal de compra.',
    },
    purchaseAmount: {
      title: 'Valor comprado no Bees/Ambev',
      content:
        'Esse é o valor que você pagou pelos seus produtos comprados no Bees/Ambev.',
    },
    expectedPurchaseAmount: {
      title: 'Valor ideal de compra no Bees',
      content:
        'Esse é o valor que você deveria ter pago no Bees para garantir o markup de 20% em cima do valor que você pagou em produtos Ambev/ABI.',
    },
    alt: 'Ícone de tooltip',
  },
  salesAmount: 'Valor bruto de vendas Ambev',
  salesAmountHeader: 'Qtd. vendida',
  purchaseAmount: 'Valor comprado no Bees/Ambev',
  expectedPurchase: 'Compra ideal',
  expectedPurchaseAmountHeader: 'Valor ideal de compra no Bees/Ambev - un',
  expectedPurchaseAmount: 'Valor ideal de compra no Bees',
  purchaseAmountAdjustment: 'Correção do preço de compra',
  purchaseAmountAdjustmentHeader: 'Correção do preço de compra - un',
  salesProfit: 'Valor recebido no app do Zé',
  totalProfit: 'Lucro final',
  markupRate: 'MarkupRate',
  understandCalculation: 'Entenda o cálculo',
  seeLess: 'ver menos',
  seeMore: 'ver mais',
  currency: 'R$',
  learnMoreAboutMarkup: 'Saiba mais sobre markup',
  defaultError: 'Houve um erro, tente novamente mais tarde.',
  product: 'Produto',
  markup: 'Markup',
  markupPercentage: '(markup 20%)',
  markupTotalPercentage: 'Markup 20%',
  purchase: 'Compra',
  purchaseAmountHeader: 'Valor de compra no Bees/Ambev - un',
  salesProfitFinal: 'Lucro final',
  salesProfitHeader: 'Lucro por produto - total',
  saleValue: 'Valor de venda no Zé - un',
  saleValueUnit: 'Venda Zé uni.',
  unit: 'un',
  order: 'Pedido',
  date: 'Data',
  ambevTotalSale: 'Total de vendas Ambev',
  markupByProducts: 'Markup por Produto',
  markupByOrders: 'Markup por Pedido',
  quantity: 'Qtd.',
  total: 'total',
  tableOf: 'Tabela de ',
  availableOnlyOnDesktopAccess: ' disponível apenas no acesso em computadores',
  tableNotAvailableAlt: 'Tabela não disponível no mobile',
  emptyTableMessage: 'Ainda não temos registros para o período selecionado.',
  downloadReport: 'baixar relatório',
  downloadReportHexa: 'Baixar relatório',
  filterByDate: 'Filtrar por data: ',
  faq: {
    mainQuestions: 'Principais Dúvidas',
    seeFaqPage: 'ver todas as dúvidas',
    seeFaqPageV2: 'Ver todas as dúvidas',
    question1: {
      title: 'O que é o Markup?',
      answer: {
        paragraph1:
          'Esse é valor que o Zé pode te pagar para corrigir seu preço de compra (markup de 20%) em cima do valor que você pagou em produtos Ambev/Bees. Isso é importante para que você não tenha prejuízo independente do preço dos produtos que vendemos no app ou site do Zé.',
        paragraph2:
          'Importante: há casos em que você consegue mais de 20% de lucro e, por isso, não repassamos o valor porque o limite definido em contrato é de 20%. Se o valor for maior que 20%, o valor excedente é debitado da correção do preço de compra. Orientamos que você consulte o contrato Zé para conferir quais são nossos acordos financeiros.',
      },
    },
    question2: {
      title: 'Como o Markup é calculado?',
      answer: {
        paragraph1: '1. Você comprou um Guaraná 2L na Ambev/Bees por R$6,62;',
        paragraph2: '2. O Zé vendeu esse Guaraná por R$ 7,89 no app ou site;',
        paragraph3: '3. Seu lucro foi de R$1,27 (R$7,89 - R$6,62);',
        paragraph4:
          '4. O Zé te promete um markup de 20% em cima do preço que você pagou em Ambev/Bees. Ou seja, 20% de R$6,62 = R$1,324;',
        paragraph5:
          '5. No entanto, seu lucro foi menor (R$1,27) do que 20% do preço que você pagou (R$1,324);',
        paragraph6:
          '6. Neste caso, considerando o preço de venda no Zé como sendo 120% (100% é o valor que você deveria ter pago na Ambev/Bees + 20% de lucro sobre esse valor);',
        paragraph7: '7. Então a conta é uma regra de três:',
        paragraph8: 'R$ 7,89 → 120%',
        paragraph9: 'X → 100%',
        paragraph10:
          'X é quanto você deveria ter pago na Ambev/Bees para que recebesse os 20% de markup. Ou seja, X = R$ 6,575;',
        paragraph11:
          '8. Portanto, já que você pagou R$6,62 na Ambev/Bees, mas deveria ter pago R$6,575, a diferença entre esses valores é o que o Zé te paga como correção do seu preço de compra.',
        paragraph12:
          'A conta resumida é: ((preço que você pagou na Ambev/Bees - (preço de venda no Zé/1,2)) → ((R$ 6,62 - (R$ 7,89/1,2)) → (R$ 6,62 - R$ 6,575) = R$ 0,045*.',
        paragraph13:
          '*Atenção: se você vende no Zé mais de 1(uma) unidade de um produto, vale lembrar que é necessário multiplicar o valor de correção preço de compra pela quantidade de produtos.',
      },
    },
    question3: {
      title: 'O que é Markup Excedente e quando ele ocorre?',
      answer: {
        paragraph1:
          'O markup excedente é quando o valor vendido ultrapassa os 20% de markup, portanto, esse valor deve ser debitado da restituição total. Alguns cenários onde isso pode acontecer são:',
        paragraph2: '1. Você comprou uma Brahma R$2,20 na Ambev/Bees',
        paragraph3: '2. O Zé vendeu esse produto por R$2,88',
        paragraph4: '3. Seu lucro foi de R$0,68 (R$2,88 - R$2,20);',
        paragraph5:
          '4. O Zé te promete um Markup de no máximo 20% em cima do preço que você pagou em Ambev/Bees. Ou seja, 20% de R$2,20 = R$0,44.',
        paragraph6:
          '5. No entanto, seu lucro foi maior (R$0,68) do que 20% do preço que você pagou (R$0,44);',
        paragraph7:
          '6. Neste caso, considerando o preço de venda no Zé como sendo 120% (100% é o valor que você deveria ter pago na Ambev/Bees + 20% de lucro sobre esse valor);',
        paragraph8: '7. Então a conta é uma regra de três:',
        paragraph9: 'R$2,88 → 120%',
        paragraph10: 'X → 100%',
        paragraph11:
          'X é quanto você deveria ter pago na Ambev/Bees para que recebesse no máximo os 20% de markup. Ou seja, X = R$ 2,40;',
        paragraph12:
          '8. Portanto, já que você pagou R$2,20 na Ambev/Bees, mas deveria ter pago R$2,40, a diferença entre esses valores é o markup excedente.',
        paragraph13:
          '9. Neste caso, o Zé debita da sua restituição total o valor excedente**, ou seja, - R$0,20*.',
        paragraph14:
          '*Atenção: se você vende no Zé mais de 1(uma) unidade de um produto que apresente markup excedente, vale lembrar que é necessário multiplicar o valor de correção preço de compra pela quantidade de produtos.',
        paragraph15:
          '**O valor excedente só poderá ser descontado da restituição de markup se houverem valores a serem pagos naquela semana. Por este motivo, você nunca estará devendo o Zé na outra semana.',
      },
    },
    question4: {
      title: 'Não houve restituição de Markup, o que aconteceu?',
      answer: {
        paragraph1: 'Essa são algumas situações que podem ter ocorrido:',
        paragraph2:
          '1. Você vendeu uma Skol 350ml no app ou site do Zé por R$2,39.',
        paragraph3:
          '2. No entanto, não encontramos os registros ou notas fiscais confirmando que você comprou esse produto em Ambev/Bees.',
        paragraph4:
          '3. Neste caso, o Zé não garante o markup de 20% em cima do valor pago na Ambev.',
        paragraph5: '4. Isso pode acontecer quando:',
        paragraph6: '- A nota fiscal excedeu os 30 dias de validade;',
        paragraph7:
          '- Por algum motivo interno, não encontramos a nota fiscal;',
        paragraph8: '- Você não comprou os produtos em Ambev/Bees.',
        paragraph9:
          '5. Para identificar esses casos, baixe sua Planilha de Restituição no Seu.Zé → Vá em na aba "Markup" e você observará que:',
        paragraph10:
          '- Na coluna "Origem do preço unitário de compra", você encontrará a descrição "Tabela padrão Zé Delivery" que indica que esses produtos não foram encontrados na Ambev;',
        paragraph11:
          '- Na coluna "Markup capturado", você encontrará a descrição "0,2" que significa 20% de markup;',
        paragraph12:
          '- Na coluna, "Restituição total", você encontrará o valor R$0,00',
      },
    },
  },
  featureDiscovery: {
    preTitle: 'Chegou a ',
    title: 'nova visualização de markup',
    subtitle: 'Ficou mais fácil de compreender os seus valores de markup.',
    item1: 'Descubra mais detalhes do cálculo',
    item2: 'Veja o lucro por produto e pedido',
    item3: 'Navegação simplificada',
    item4: 'Mais transparência',
  },
  financialMovement: {
    financialMovementTab: 'Movimentações Financeiras',
    periodDetail: 'Detalhes do período',
    category: 'Categoria',
    debit: 'Débito',
    credit: 'Crédito',
    dinamic: 'Dinâmico',
    //because of a business rule it needs to be like this
    discount: 'Cupom',
    fixed: 'Fixo',
    markup: 'Markup',
    manual: 'Manual',
    coupon: 'Cupom',
    cashback: 'Cashback',
    marketplace: 'Marketplace',
    incentive: 'Incentivo',
    shipping: 'Frete',
    others: 'Outros',
    tooltip: {
      dinamic: {
        content:
          'Esse é o saldo referente aos valores que o Zé restitui. Ex: Markup, Cupons, Cashbacks, etc.',
      },
      fixed: {
        content:
          'Esse saldo é referente à valores de frete. Sempre que houver entrega você receberá esse valor, mesmo que os demais estejam negativos.',
      },
    },
    errorMessage: 'Não conseguimos recuperar os dados nesse momento.',
    tryAgain: 'Tente novamente mais tarde',
    notFoundImg: 'Não encontrado',
    sectionSummaryPayments: {
      titleCard: 'Saldo recebido',
      explanationInfoDate: 'Valores referentes a operacão da semana',
      contentCard: 'Composição do saldo',
      accumulatedCard: 'Acumulado',
      dynamicCard: 'Dinâmico',
      fixedCard: 'Fixo',
      accumulatedTextTooltip:
        'Esse é o saldo referente a semana anterior. Caso ele seja positivo, o Zé te pagará um valor a mais. Caso seja negativo, esse valor será descontado do saldo total. Ficou com dúvida? Verifique as ',
      accumulatedTextTooltip2: 'perguntas frequentes',
      dynamicTextTooltip:
        'Esse é o saldo referente aos valores que o Zé restitui. Ex: Markup, Cupons, Cashbacks, etc.',
      fixedTextTooltip:
        'Esse saldo é referente à valores de frete. Sempre que houver entrega você receberá esse valor, mesmo que os demais estejam negativos.',
      parentheses: '(',
      at: 'até',
      parentheses2: ')',
      error:
        'Não conseguimos recuperar os dados de ontem no momento. Tente novamente mais tarde',
      emptyValue: '-',
      welcomeMessage:
        'Essa nova página vai trazer mais clareza sobre os valores recebidos e devidos ao Zé Delivery.',
    },
  },
  faqFinancialMovement: {
    frequentlyAsked: 'Dúvidas Frequentes',
    seeFaqPage: 'ver todas as dúvidas',
    question1: {
      title: 'O que são movimentações financeiras?',
      answer: {
        paragraph1:
          'Movimentações financeiras referem-se aos diversos valores financeiros que fazem parte da parceria conosco.',
        paragraph2:
          'Essa seção permite que você acompanhe de forma clara e organizada os fluxos de entrada e saída de recursos, como os valores que o Zé te restitui (Incentivo operacional e frete, por exemplo) e os que o Zé cobra da sua loja (taxa de Marketplace), visando transparência e clareza nos repasses financeiros semanais.',
      },
    },
    question2: {
      title:
        'As movimentações financeiras do Zé tem alguma relação com a minha conta corrente pessoal ou da minha loja?',
      answer: {
        paragraph1:
          'Não! A conta virtual do Zé não tem nenhuma relação com a sua conta bancária! Ou seja, a única interação que teremos com sua conta bancária serão as transferências semanais dos repasses, como já era feito desde o início da parceria. Os saldos dinâmico, fixo e acumulado mencionados nesta tela são valores de controle interno do Zé, utilizados para gerar uma melhor gestão e transparência financeira da parceria.',
      },
    },
    question3: {
      title: 'O que mudou nos meus pagamentos?',
      answer: {
        paragraph1:
          'As principais mudanças são a inclusão do saldo acumulado, onde quando o valor da semana corrente ficar negativo, ele não mais será zerado, e sim acumulado para a próxima semana (lembrando que o saldo dinâmico negativo não será descontado do saldo fixo de frete); e a criação do saldo fixo, referente ao frete que está garantido para você semanalmente.',
      },
    },
    question4: {
      title: 'Quais os novos tipos de saldos que compõem o meu pagamento?',
      answer: {
        paragraph1:
          'O Saldo recebido é o valor repassado pelo Zé Delivery para você semanalmente. Esse saldo é referente à soma do Saldo Fixo + Saldo dinâmico e, quando for o caso, soma ou desconto do saldo acumulado.',
        paragraph2:
          'Saldo fixo (Denominado "Saldo normal" no seu termo geral): Esse saldo é referente à valores de frete. Mesmo que os demais estejam negativos, esse valor é garantido semanalmente de acordo com o nº de pedidos realizados na semana anterior.',
        paragraph3:
          'Saldo dinâmico (Denominado "Saldo bônus" no seu termo geral): Esse é o saldo referente aos valores que o Zé restitui. Ex: Markup, Cupons, Cashbacks, etc. Caso existam pendências financeiras da loja com o Zé, descontaremos desse saldo para pagamento dos valores devidos, por exemplo, taxa de Marketplace.',
        paragraph4:
          'Saldo acumulado: Esse é o saldo pendente de pagamento referente a semana anterior. Esse saldo ocorre quando o saldo dinâmico é menor do que os valores devidos em taxas, como Comissão de Marketplace e Markup negativo (nesse caso, o saldo dinâmico é zerado e o excedente fica como saldo acumulado para a semana seguinte); quando ocorrem erros nos processamentos (nesse caso, o valor fica como crédito e é pago na semana seguinte); e quando existem valores provenientes de correções de pagamento.',
      },
    },
    question5: {
      title: 'O que são esses valores negativos?',
      answer: {
        paragraph1:
          'Valores negativos: Referem-se às taxas da plataforma (marketplace fee e Markup excedente) e ocorrem quando a soma dos valores positivos for menor do que o total de negativos (marketplace fee, Markup excedente e descontos manuais), nesse caso, seu saldo fica negativo e é acumulado para a próxima semana, constando na linha "Saldo Acumulado" da semana seguinte.',
        paragraph2:
          'Atenção: Observe que nesses casos de valores negativos (em vermelho) maiores que os positivos, o seu saldo total a ser pago na semana corrente será constituído somente do seu saldo fixo (fretes).',
      },
    },
    question6: {
      title:
        'Quando as informações de valores sobre os meus pagamentos são atualizadas?',
      answer: {
        paragraph1:
          'As informações sobre seus pagamentos são processadas pelo nosso time interno, geralmente, às terças-feiras de cada semana. Portanto, caso entre nessa página e a descrição dos valores que serão pagos na semana corrente estejam zerados, aguarde alguns dias e consulte novamente. Atente-se sempre à semana selecionada no calendário da página, pois essa página mostra o acumulado dos pagamentos semanais.',
      },
    },
    question7: {
      title: 'Quando vou receber meu pagamento na minha conta bancária?',
      answer: {
        paragraph1:
          'Os pagamentos são feitos entre quarta e quinta-feira de cada semana. O valor é transferido diretamente para sua conta bancária cadastrada na plataforma do Seu Zé.',
      },
    },
    question8: {
      title: 'O que fazer quando meus valores estiverem incorretos?',
      answer: {
        paragraph1:
          'Caso suspeite de que seus valores estão incorretos, entre em contato com nossa equipe através do chat no canto inferior esquerdo da sua tela do Seu Zé ou envie um e-mail para notasfiscais@ze.delivery.',
      },
    },
  },
  cards: {
    salesAmount: {
      title: 'Vendas Ambev',
      description: 'Valor bruto',
      tooltip: 'Essa é a soma dos produtos da Ambev vendidos por você no Zé.',
    },
    purchaseAmount: {
      title: 'Valor comprado no Bees/Ambev',
      description: 'Valor pago',
      tooltip:
        'Esse é o valor que você pagou pelos seus produtos comprados no Bees/Ambev.',
    },
    expectedPurchaseAmount: {
      title: 'Valor ideal de compra no Bees',
      description: 'Projeção',
      tooltip:
        'Esse é o valor que você deveria ter pago no Bees para garantir o markup de 20% em cima do valor que você pagou em produtos Ambev/ABI.',
    },
    purchaseAmountAdjustment: {
      title: 'Correção do preço de compra',
      description: 'Markup',
      tooltip:
        'Esse é o valor que o Zé te paga para corrigir seu preço de compra e garantir o markup de 20% em cima do valor que você pagou em produtos Ambev/ABI.',
    },
    salesProfit: {
      title: 'Valor recebido no app do Zé',
      description: 'Valor recebido',
      tooltip:
        'Esse é o valor que você recebeu do cliente sem contabilizar o que te pagamos.',
    },
    totalProfit: {
      title: 'Lucro final',
      description: 'Valor total após descontos',
      tooltip:
        'Esse é o valor que você lucrou após ter vendido todos os seus produtos Ambev/ABI. Aqui fica o valor final que inclui a correção do preço ideal de compra.',
    },
  },
}

export default FINANCIAL_REPORT
